import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { AvailableDeliveryMethodsDetail } from "interfaces/session/ShoppingCart";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import HideIf from "util/HideIf";
import { selectedDeliveryMethodDetails } from "../helper/selectedDeliveryMethodDetails";
import styles from "./deliveryCounter.module.scss";

interface IProps {
  deliveryMethod: string;
  availableDeliveryMethodsDetails: AvailableDeliveryMethodsDetail[];
}

function DeliveryCounter(props: IProps) {
  const { deliveryMethod, availableDeliveryMethodsDetails } = props;
  const selectedDeliveryMethod = selectedDeliveryMethodDetails(deliveryMethod, availableDeliveryMethodsDetails);
  const { t } = useTranslation("shopping-cart");

  const { countDownHours = 0, countDownMinutes = 0 } = selectedDeliveryMethod || {};
  const [timer, setTimer] = useState({
    hours: countDownHours,
    minutes: countDownMinutes,
  });

  useEffect(() => {
    const deliveryTimeInterval = setInterval(() => {
      setTimer((prevTimer) => {
        const { hours: oldHours, minutes: oldMinutes } = prevTimer;
        let newHours = oldHours;
        let newMinutes = oldMinutes;
        if (oldMinutes > 0) {
          newMinutes = oldMinutes - 1;
        } else if (oldMinutes === 0) {
          if (oldHours === 0) {
            clearInterval(deliveryTimeInterval);
          } else {
            newMinutes = 59;
            newHours = oldHours - 1;
          }
        }
        return {
          hours: newHours,
          minutes: newMinutes,
        };
      });
    }, 1000 * 60);

    return () => {
      clearInterval(deliveryTimeInterval);
    };
  }, []);

  useEffect(() => {
    setTimer({
      hours: countDownHours,
      minutes: countDownMinutes,
    });
  }, [deliveryMethod]);

  if (!selectedDeliveryMethod) {
    return null;
  }

  return (
    <HideIf show={!(timer.hours === 0 && timer.minutes === 0)}>
      <div>
        <PAText className={styles.normal_weight} fontSize={FONT_SIZE[0]}>
          {t("Order within")}
        </PAText>
                &nbsp;
        <PAText color="success-primary" className={styles.normal_weight} fontSize={FONT_SIZE[0]}>
          {timer.hours ? `${timer.hours} ${t("hrs")}` : ""}
          {timer.minutes ? `${timer.hours ? " " : ""}${timer.minutes} ${t("mins")}` : ""}
        </PAText>
        <PAText className={styles.normal_weight} fontSize={FONT_SIZE[0]}>
          {` ${t("for this delivery window")}`}
        </PAText>
      </div>
    </HideIf>
  );
}

export default DeliveryCounter;
